<template>
  <svg fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.94063 13.3118C5.05978 11.9054 1.3335 8.68991 1.3335 5.79633C1.3335 3.88379 2.737 2.33337 4.66683 2.33337C5.66683 2.33337 6.66683 2.66671 8.00016 4.00004C9.3335 2.66671 10.3335 2.33337 11.3335 2.33337C13.2633 2.33337 14.6668 3.88379 14.6668 5.79633C14.6668 8.68991 10.9406 11.9054 9.0597 13.3118C8.42676 13.7851 7.57356 13.7851 6.94063 13.3118Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.25"
    />
  </svg>
</template>
